import { playerManager } from '../core/player-manager.js';
import { bus } from '../core/event-bus.js';
import { store } from '../core/state-store.js';

export function initControls() {
  const play = document.getElementById('btn-play');
  const pause = document.getElementById('btn-pause');
  const stop = document.getElementById('btn-stop');
  const skip = document.getElementById('btn-skip');
  const fullscreen = document.getElementById('btn-fullscreen');
  const mute = document.getElementById('btn-mute');
  const unmute = document.getElementById('btn-unmute');
  const volume = document.getElementById('volume-slider');
  let lastNonZeroVolume = 1;

  const clampVolume = (val) => Math.max(0, Math.min(1, Number.isFinite(val) ? val : 1));

  const syncControlsUi = () => {
    const state = store.state;
    const currentVolume = clampVolume(state.volume);
    const isMuted = Boolean(state.muted) || currentVolume === 0;

    if (currentVolume > 0) {
      lastNonZeroVolume = currentVolume;
    }

    volume.value = String(Math.round(currentVolume * 100));
    mute.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
    unmute.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
  };

  const applyMuteState = (shouldMute) => {
    const currentVolume = clampVolume(playerManager.volume);

    if (shouldMute && currentVolume > 0) {
      lastNonZeroVolume = currentVolume;
    }

    if (shouldMute) {
      playerManager.muted = true;
      playerManager.volume = 0;
      store.update({ muted: true, volume: 0 });
      return;
    }

    const restoreVolume = clampVolume(lastNonZeroVolume || 1);
    playerManager.muted = false;
    if (currentVolume === 0) {
      playerManager.volume = restoreVolume;
      store.update({ muted: false, volume: restoreVolume });
      return;
    }
    store.update({ muted: false, volume: currentVolume });
  };

  play.addEventListener('click', () => playerManager.play());
  pause.addEventListener('click', () => playerManager.pause());
  stop.addEventListener('click', () => playerManager.stop());
  skip.addEventListener('click', () => playerManager.skip());
  fullscreen.addEventListener('click', () => playerManager.toggleFullscreen());

  mute.addEventListener('click', () => {
    applyMuteState(true);
  });

  unmute.addEventListener('click', () => {
    applyMuteState(false);
  });

  volume.addEventListener('input', () => {
    const nextVolume = clampVolume(parseInt(volume.value, 10) / 100);
    playerManager.volume = nextVolume;
    playerManager.muted = nextVolume === 0;
    if (nextVolume > 0) {
      lastNonZeroVolume = nextVolume;
    }
    store.update({ volume: nextVolume, muted: nextVolume === 0 });
  });

  bus.on('state:changed', ({ changed = [] }) => {
    if (changed.includes('volume') || changed.includes('muted')) {
      syncControlsUi();
    }
  });

  bus.on('player:tick', syncControlsUi);
  syncControlsUi();
}
